import {DeviceQuality, Size2D, IService, SystemComponentType} from '@gongxigames/framework/core/types';
import {CoreDI, CoreSettings} from '@gongxigames/framework/core/configs';
import {inject, injectable} from '@gongxigames/framework/core/installer';
import {Device} from '@gongxigames/framework/core/services/Device';

@injectable()
export class ResolutionManager implements IService {
    public static NAME: symbol = CoreDI.ResolutionManager;
    public type: SystemComponentType = 'service';

    private _resolution!: Size2D;

    @inject(CoreDI.Device)
    private readonly _device!: Device;

    @inject(CoreDI.Settings)
    private readonly _settings!: CoreSettings;

    public init(): void {
        const ratio = this._device.getPixelRatio();
        const screenWidth = Math.max(screen.width, screen.height) * ratio;
        const forceResolutionWidth = this._settings.get('resolution');

        if (forceResolutionWidth) {
            switch (forceResolutionWidth) {
                case 960: {
                    this._resolution = {width: 960, height: 540};
                    break;
                }
                case 1280: {
                    this._resolution = {width: 1280, height: 720};
                    break;
                }
                case 1920: {
                    this._resolution = {width: 1920, height: 1080};
                    break;
                }
                case 3840: {
                    this._resolution = {width: 3840, height: 2160};
                    break;
                }
                default: {
                    break;
                }
            }
        } else {
            if (this._device.desktop) {
                if (screenWidth < 1440 || this._device.quality <= DeviceQuality.LOW) {
                    this._resolution = {width: 1280, height: 720};
                } else {
                    this._resolution = {width: 1920, height: 1080};
                }
            } else {
                if (this._device.quality <= DeviceQuality.LOW) {
                    this._resolution = {width: 960, height: 540};
                } else {
                    this._resolution = {width: 1280, height: 720};
                }
            }
        }
    }

    /**
     * Resolution: graphics quality for resources, software text etc...
     */
    public get resolution(): Readonly<Size2D> {
        return this._resolution;
    }

    /**
     * "PixelRatio" for generated text and sprites.
     * Sets the quality of image.
     * Should be similar to resolution multiplier of image resources
     * from resources builder
     */
    public get pixelRatio(): number {
        return this._resolution.width / 3840;
    }
}
